module.exports = __webpack_public_path__ + "static/media/spot16.59ccd5dc.webp";